import { PaidForDetails } from '../../../shared/models/TrustFieldsRequestInfo';
import { CheckDeliveryCodes, StringBoolean, YesNo } from '../../../shared/utilities/Constants';
import { AccountDisplayRecord } from '../ach/AccountDisplayRecord';
import { FeeDetail, MailAddressDetails, PayeeDetails } from './CheckData';

export interface CheckVerifyRequest {
    draftId?: string
    nextProcessDate?: string;
    isThirdParty: boolean;
    accountDisplayRecord: AccountDisplayRecord;
    recipientAddressType: string;
    payeeType: string;
    subAccountId: string;
    masterAccountId: string;
    sloaPopupSelected: boolean;
    altrInd: boolean;
    altrText: string;
    accountPlatformCode: string;
    formType: string;
    bsloatransaction: boolean;
    memo: string;
    recipient: RecipientAddressDetails;
    defaultPayee: string[];
    IsFirstPartyModified: boolean;
    payeeDetails: PayeeDetails;
    nickname?: string;
    useConstructedPayee: boolean;
    payeeLine1: string;
    payeeLine2: string;
    payeeLine3: string;
    otherDomesticmailTo1: string;
    otherDomesticmailTo2: string;
    otherDomesticmailTo3: string;
    otherDomesticstreetAddr1: string;
    otherDomesticstreetAddr2: string;
    otherDomesticAddrCity: string;
    otherDomesticAddrState: string;
    otherDomesticAddrZipCode: string;
    otherForeginmailTo1: string;
    otherForeginmailTo2: string;
    otherForeginmailTo3: string;
    otherForeginstreetAddr1: string;
    otherForeginstreetAddr2: string;
    otherForeginAddrCountry: string;
    otherForeginAddrCity: string;
    otherForeginAddrState: string;
    otherForegincAddrZipCode: string;
    withdrawalReasonCode: string;
    withdrawalReason: string;
    processDateMM: number | string;
    processDateDD: number | string;
    processDateYYYY: number | string;
    distributionReasonCdValue: string;
    distributionReasonCd: string;
    distributionReasonSubCd: string;
    stateTaxRtTWE: number;
    fedTaxRtTWE: number;
    withholdTaxes: YesNo;
    stateTaxAmount: number;
    fedTaxAmount: number;
    withholdStateTaxes: YesNo;
    fedTaxAmountFormatted: string,
    stateTaxAmountFormatted: string,
    totalWithdrawalAmount: string,
    IRAAccount: boolean;
    stateTaxAttentionRequiredMI: StringBoolean; // These are string booleans (lol) in the current ui's request
    stateTaxAttentionRequiredOther: StringBoolean;
    isNonNAState: boolean;
    amount: string;
    amountType: string;
    DeliveryMethodCode: CheckDeliveryCodes;
    feeDetail: FeeDetail;
    isEdit: boolean;
    actvTweIn: boolean;
    cashieringReqId: number;
    cashieringSecondReqId: number;
    frequency?: string;
    frequencyDescription?: string;
    payIncome?: KeyValue;
    recurringTxn?: RecurringTransaction;
    Recipientusesloa?: MailAddressDetails[];
    MailAddressTypeCode?: string;
    CheckPayeeTypeCode?: string;
    MemoLine2?: string;
    MemoLine2DescriptionCode?: string;
    //Begin additional InR fields -- can be cleaned up when Legacy is retired (if not in use here)
    memoLine1CustomerId?: number;
    notNAState?: boolean;
    rmdEligible?: boolean;
    isFromSLOA?: boolean;
    stateCd?: string;
    stateMoveErrorCd?: number;
    stateMoveErrorMsg?: string;
    AssignToUserId?: string;
    stateTypeInd?: string;
    sloaRecipient?: string[];
    isTrust?: boolean;
    paidFor?: PaidForDetails;
    trustIncmPct?: string
    trustPrinPct?: string;
    trustTaxCode?: string;
    trustTaxCategory?: string;
    tranMemo?: string;
    //End additional InR fields
}

export class KeyValue {
    key: string;
    value: string;

    constructor(key?: string, value?: string) {
        this.key = key ?? '';
        this.value = value ?? '';
    }
}

export interface RecurringTransaction {
    payIncome: { code: string };
    nextProcessDateDD?: number;
    nextProcessDateMM?: number;
    nextProcessDateYYYY?: number;
    process2ndDateMM?: number;
    process2ndDateDD?: number;
    process2ndDateYYYY?: number;
    endDateMM?: number;
    endDateDD?: number;
    endDateYYYY?: number;
}

export interface RecipientAddressDetails {
    addressLine1: string;
    addressLine2: string;
    addressLine3: string;
    city: string;
    regionName: string;
    stateName: string;
    stateCode: string;
    countryCode: string;
    countryName: string;
    zipCode: string;
    zipSuffCode: string;
}
